import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import { getDepositInterestType} from '../../utils/compare/CompareUtilities';
import * as gtag from '../../cookie/lib/gtag';

const CreditCardDetails = (props) => {
    const {show, handleClose, details, applyParams, product} = props;

    let provider  = details.showLogo ? 
                    <Image 
                        src={details.providerLogo} 
                        height={details.logoSize.height} 
                        width={details.logoSize.width}
                    /> 
                    :
                    <p>{details.bank}</p>;

    let relOpennerTag;
    if (details.hasOwnProperty('apply')) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else {
        relOpennerTag = '';
    }

    const onApply = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) { 
            gtag.event('Apply', {
                provider: details.provider,
                product: product,
            });
        } else {
            console.log("beta");
        }
        handleClose();
    }


    return (
        <Modal show={show} onHide={handleClose} dialogClassName={styles.modal90w}>
            <Modal.Header closeButton>
                <Modal.Title>             
                    {provider}
                    <p className={`${styles.productName} text-muted mb-0`}>{details.product}</p>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                        `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                        : 
                        details.apply
                    }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                                <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Cost total
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        DAE cumpărături
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.purchaseApr)}%
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        DAE numerar
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.cashApr)}% 
                    </Col>  
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                    Rata dobânzii
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Pentru cumpărături
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.purchaseInterestRate)}%, {getDepositInterestType(details.rateType)}
                        { details.rateType=='variable' &&
                            <> ({Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.purchaseInterestMargin)}% + IRCC)
                            </>
                        }
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Pentru retragere numerar
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.cashInterestRate)}%, {getDepositInterestType(details.rateType)}
                        { details.rateType=='variable' &&
                            <> ({Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.cashInterestMargin)}% + IRCC)
                            </>
                        }
                    </Col>  
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Comisioane
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Taxa de emitere
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.issuingFee}
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Taxa administrare
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.managementFee} 
                    </Col>  
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Costuri la tranzacții
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Plăți la comercianți
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.purchaseFeeNational}
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Plăți în străinătate
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.purchaseFeeForeign} 
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Retragere numerar - ATM bancă
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.cashWithdrawalBankATM} 
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Retragere numerar - ATM din țară
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.cashWithdrawalNationalATM} 
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Retragere numerar - ATM din străinătate
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.cashWithdrawalForeignATM} 
                    </Col>  
                </Row>

                <Row className={styles.endSection}>
                    <Col xs="12" className={styles.productSection}>
                        Rambursare credit
                    </Col>
                    <Col xs="12" md="5" className={styles.key}>
                        Perioada de grație
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        până la {details.graceMaxPeriod} zile
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Tranzacții cu perioadă de grație
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.gracePeriodTransaction}
                    </Col>  
                    <Col xs="12" md="5" className={styles.key}>
                        Suma minimă de plată
                    </Col>
                    <Col xs="12" md="7" className={styles.info}>
                        {details.minimumPayment} 
                    </Col>  
                </Row>
        
                {details.category.includes('cashback') &&
                    <Row className={styles.endSection}>
                        <Col xs="12" className={styles.productSection}>
                            Program cashback
                        </Col>
                        <Col xs="12" className={styles.info} 
                            dangerouslySetInnerHTML={{__html: details.cashbackInfo}}
                            >
                        </Col>
                         
                    </Row>
                }   

                {details.category.includes('rewards') &&
                    <Row className={styles.endSection}>
                        <Col xs="12" className={styles.productSection}>
                            Program Puncte Bonus
                        </Col>
                        <Col xs="12" className={styles.info} 
                            dangerouslySetInnerHTML={{__html: details.rewardsInfo}}
                            >
                        </Col>    
                    </Row>
                }   

                {details.category.includes('freeInterest') &&
                    <Row className={styles.endSection}>
                        <Col xs="12" className={styles.productSection}>
                            Program Rate cu 0% dobândă
                        </Col>
                        <Col xs="12" className={styles.info} 
                            dangerouslySetInnerHTML={{__html: details.freeInterestInfo}}
                            >
                        </Col>    
                    </Row>
                } 

                {details.otherBenefitsInfo &&
                    <Row className={styles.endSection}>
                        <Col xs="12" className={styles.productSection}>
                            Diverse beneficii
                        </Col>
                        <Col xs="12" className={styles.info} 
                            dangerouslySetInnerHTML={{__html: details.otherBenefitsInfo}}
                            >
                        </Col>    
                    </Row>
                }   

                {details.category.includes('balanceTransfer') &&
                    <Row className={styles.endSection}>
                        <Col xs="12" className={styles.productSection}>
                            Condiții de refinanțare
                        </Col>
                        <Col xs="12" className={styles.info} 
                            dangerouslySetInnerHTML={{__html: details.balanceTransferInfo}}
                            >
                        </Col>    
                    </Row>
                }   


            </Modal.Body>
            <Modal.Footer className="justify-content-between" >  
                {details.hasOwnProperty('apply') && 
                <Link
                    href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                        `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                        : 
                        details.apply
                    }
                    onClick={onApply}
                    rel={relOpennerTag}
                    target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                    title="Solicită oferta"
                    className="btn btn-primary mt-2 mb-3">
                    Solicită oferta
                                                <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                </Link>    
                } 

            
                <Button variant="outline-secondary" onClick={handleClose}>
                    Închide
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreditCardDetails;